import React from 'react'
import { Box, Display, FlexDirection, GridDisplay } from '@gousto-internal/citrus-react'

import type {
  CollectionSlug,
  CollectionUUID,
  ParentCategory as ParentCategoryType,
} from '@library/menu-service'
import { GenericCategoryTile, PromotedCategoryTile } from '../CategoryTile'
import { ParentCategoryHeader } from '../ParentCategoryHeader/ParentCategoryHeader'

export type ParentCategoryProps = {
  id: CollectionUUID
  slug: CollectionSlug
  categories: ParentCategoryType['categories']
  description?: string
  isFeaturedRangeMerchandisingEnabled?: boolean
  isLinkable: boolean
  type: 'generic' | 'promoted'
  name: string
  recipeCount: number
  onCategoryClick: (
    categoryId: CollectionUUID,
    slug: CollectionSlug,
    parentCollectionId?: CollectionUUID,
  ) => void
}

export const ParentCategory = ({
  id,
  slug,
  categories,
  description,
  isFeaturedRangeMerchandisingEnabled = false,
  isLinkable,
  type,
  name,
  recipeCount,
  onCategoryClick,
}: ParentCategoryProps) => {
  const TileComponent =
    isFeaturedRangeMerchandisingEnabled && type === 'promoted'
      ? PromotedCategoryTile
      : GenericCategoryTile

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={3}>
      <ParentCategoryHeader
        id={id}
        slug={slug}
        description={description}
        isLinkable={isLinkable}
        type={type}
        name={name}
        recipeCount={recipeCount}
        onCategoryClick={onCategoryClick}
      />
      <Box
        display={GridDisplay.Grid}
        gridTemplateColumns={[
          'repeat(2, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))',
          'repeat(3, minmax(0, 1fr))',
          'repeat(4, minmax(0, 1fr))',
        ]}
        gap={[4, 6]}
      >
        {categories.map(({ id: categoryId, slug, shortTitle, recipeCount, image }) => (
          <TileComponent
            key={categoryId}
            title={shortTitle}
            imageCrops={image?.crops}
            recipeCount={recipeCount}
            onClick={() => onCategoryClick(categoryId, slug, id)}
          />
        ))}
      </Box>
    </Box>
  )
}
